import { useState, useEffect } from 'react';
import { useMediaQuery } from '@mui/material';

import { useGetClawingInsectsColumns } from './useGetClawingInsectsColumns';
import ClawingInsectsExpandable from './ClawingInsectsExpandable';

import FilterDataTable from 'components/FilterDataTable/FilterDataTable';
import useGetCrawlingInsectsTraps from 'hooks/Traps/CrawlingInsectsTraps/useGetCrawlingInsectsTraps';
import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';
import { CrawlingInsectsTrap } from 'api/traps/CrawlingInsectsTrap/types';

interface TableProps {
  slug: string;
}

const ClawingInsectsTable: React.FC<TableProps> = ({ slug }) => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const { data, refetch, isLoading } = useGetCrawlingInsectsTraps(slug || '', page, search, ordering);

  const columns = useGetClawingInsectsColumns(slug);
  const isNotLargeDesktop = useMediaQuery(MediaBreakpoints.largeDesktop);

  useEffect(() => {
    refetch();
  }, [page, ordering, search, refetch]);

  return (
    <div className="bg-white ">
      <FilterDataTable<CrawlingInsectsTrap>
        columns={columns}
        data={data?.results || []}
        onChangePage={setPage}
        onChangeFilterParams={setQueryParam}
        onChangeSearch={setSearch}
        isLoading={isLoading}
        expandableRows={isNotLargeDesktop}
        expandableRowsComponent={row => <ClawingInsectsExpandable data={row.data} slug={slug} />}
      />
    </div>
  );
};

export default ClawingInsectsTable;
